{
  "close": "Zavřít",
  "notifications": "{count, plural, one {# oznámení} other {# oznámení}}."
}
